<template>
  <div class="userWrapFK">
	<div class="userListFK">
		<ul>
			<li>
				<div class="poWrapFK">
					<div class="L"><em>福卡包</em></div>
					<div class="R">五张可用<i class="iconfont iconxiangyoujiantou"></i></div>
				</div>
			</li>
			<li>
			   <div class="poWrapFK">
					<div class="L"><em>福卡包</em></div>
					<div class="R">五张可用<i class="iconfont iconxiangyoujiantou"></i></div>
				</div>
			</li>
		
		</ul>
	</div>  
  </div>   

</template>

<script>
 import * as api from '@/api'
  	export default {
    data(){
      return {
	
      }
    },
  
   components: {
			
			
	 },

	mounted(){
	
	},
    methods:{
		 async workexp(){
          try{
            const {code,data,message} = await api.user.workexp()
      
            if(code === 200){
              this.docslist = data
              console.log(this.docslist)
            }else{
              // HyrToast(submsg || msg)
            }
          }catch(err){
            console.log(err)
          }
        },
   }
  }
</script>

<style lang="stylus">
@import '../../assets/css/layout.styl'
@import '../../assets/css/common.styl'
@import '../../assets/css/icon.css'
.userWrapFK 
  width 100%
  height 100%
  overflow auto
  background #f5f5f5
  .userListFK{
   li{
     width: 100%
	 height: 265px
	 margin: 20px 0
	 background: #fff
     display :flex
	 .poWrapFK{
       width: calc(100% - 40px)
	   align-self: center
	   margin: 20px	auto
	   i{
		   vertical-align:middle
		   font-size 18px
	   }
	 }
	
		
	   
     } 
   }
.L{
	float left
}
.R{
	float right
}



	
</style>



// WEBPACK FOOTER //
// src/view/movielist/index.vue